import { isNil } from 'lodash';
import { useQuery } from '../useQuery';
import { getCWSSummary } from '@dispatch/shared/services';

export const useGetCWSSummary = (cwsNumber?: string, enabled?: boolean) => {
  const { data, refetch, status } = useQuery(
    ['cwsSummary', cwsNumber],
    () => {
      return getCWSSummary(cwsNumber);
    },
    {
      enabled: !isNil(enabled) ? enabled : false,
    }
  );

  return {
    summary: data,
    refetchCwsSummary: refetch,
    status,
  };
};
